// 접속 비밀번호 입력 게이트 (Turnstile 봇 방지 적용)
import { useEffect, useRef, useState } from 'preact/hooks';
import { api, ApiError } from '../core/ApiClient';
import { PasswordInput } from './PasswordInput';
import { TURNSTILE_SITE_KEY } from '../core/turnstile';

interface Props {
  siteTitle: string;
  onLoggedIn: () => void;
}

export function LoginGate({ siteTitle, onLoggedIn }: Props) {
  const [password, setPassword] = useState('');
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);
  const [token, setToken] = useState('');
  const widgetRef = useRef<HTMLDivElement>(null);
  const rendered = useRef(false);

  // Turnstile 위젯 렌더 (스크립트 로드 대기)
  useEffect(() => {
    if (!TURNSTILE_SITE_KEY) return;
    let timer: ReturnType<typeof setTimeout>;
    const tryRender = () => {
      if (rendered.current) return;
      const ts = window.turnstile;
      if (ts && widgetRef.current) {
        rendered.current = true;
        ts.render(widgetRef.current, {
          sitekey: TURNSTILE_SITE_KEY,
          callback: (t) => setToken(t),
          'error-callback': () => setToken(''),
          'expired-callback': () => setToken(''),
        });
      } else {
        timer = setTimeout(tryRender, 200);
      }
    };
    tryRender();
    return () => clearTimeout(timer);
  }, []);

  const needToken = TURNSTILE_SITE_KEY && !token;

  const submit = async (e: Event) => {
    e.preventDefault();
    setErr('');
    if (needToken) return setErr('보안 확인을 완료해 주세요.');
    setBusy(true);
    try {
      await api.login({ password, turnstileToken: token });
      onLoggedIn();
    } catch (ex) {
      setErr(ex instanceof ApiError ? ex.message : '로그인에 실패했습니다.');
      setBusy(false);
      window.turnstile?.reset();
      setToken('');
    }
  };

  return (
    <div class="gate">
      <form class="gate__card" onSubmit={submit}>
        <img class="gate__logo" src="/logo.webp" alt="로고" />
        <h1 style="font-size:18px;margin:0 0 16px">{siteTitle}</h1>
        <div class="field">
          <PasswordInput value={password} onValue={setPassword} placeholder="비밀번호" autoFocus />
        </div>
        {TURNSTILE_SITE_KEY && <div class="turnstile" ref={widgetRef} />}
        <button class="btn btn--primary" type="submit" style="width:100%" disabled={busy || !!needToken}>
          {busy ? '확인 중…' : '입장'}
        </button>
        {err && <div class="msg-error">{err}</div>}
      </form>
    </div>
  );
}
